import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function PastContent(props) {
  const { place } = props
  const [times, setTimes] = useState([]);
  const [selectedtime, setSelectedtime] = useState('')
  const [image, setImage] = useState([0]);
  const [nextTime, setNextTime] = useState(undefined);
  const [prevTime, setPrevTime] = useState(undefined);
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedDateTime, setSelectedDateTime] = useState('')
  const [dates, setDates] = useState([])
  const [dateTimes, setDateTimes] = useState([])

  const handleDateChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedDate(value);
  };

  const handleTimeChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedtime(value);
    setSelectedDateTime(selectedDate + 'T' + value)
  };

  const handleNextClick = (event) => {
    const dateTime = dateTimes[nextTime]
    setSelectedDateTime(dateTime)
    setSelectedDate(dateTime.split('T')[0])
    setSelectedtime(dateTime.split('T')[1])
  };

  const handlePrevClick = (event) => {
    const dateTime = dateTimes[prevTime]
    setSelectedDateTime(dateTime)
    setSelectedDate(dateTime.split('T')[0])
    setSelectedtime(dateTime.split('T')[1])
  };

  const output_image = (image) => {
    if (image!==0){
      return <img src={image} alt='output'/>
    }
  }

  useEffect(() => {
    if (place.length == 0) return;
    axios.get(`/api/image/times/${place}`).then(res => {
      const dateTimeArr = Array.from(new Set(res.data)) // 重複があったらうまく動作しないので削除
      setDateTimes(dateTimeArr)

      const dateArr = Array.from(new Set(dateTimeArr.map(item => item.split('T')[0])))
      setDates(dateArr)
      if (dateTimeArr.length > 0) {
        setSelectedDateTime(dateTimeArr[0])
        setSelectedDate(dateArr[0])
      }
    })
  }, [place])

  useEffect(() => {
    if (selectedDate){
      const timeArr = dateTimes.filter(dateTime => dateTime.startsWith(selectedDate)).map(item => item.split('T')[1])
      setTimes(timeArr)
      if (dateTimes.indexOf(selectedDateTime) === -1) {
        setSelectedtime(timeArr[0])
        setSelectedDateTime(selectedDate + 'T' + timeArr[0])
      } else {
        setSelectedtime(selectedDateTime.split('T')[1])
      }
    }
  }, [selectedDate])

  useEffect(() => {
    if (place.length == 0) return;
    if (selectedDateTime){
      axios.get(`/api/image/time/${place}/${selectedDateTime}`, {responseType: 'blob',}).then( res => {
        setImage([URL.createObjectURL(res.data)])
      })
      const index = dateTimes.indexOf(selectedDateTime)
      if (index > 0) {
        setNextTime(parseInt(index - 1))
      } else {
        setNextTime(undefined)
      }
      if (index < dateTimes.length - 1) {
        setPrevTime(parseInt(index + 1))
      } else {
        setPrevTime(undefined)
      }

    }
  }, [place, selectedDateTime])

  return (
    <div class="bl_pastPic">
      <div class="bl_picInner">
        <div class="bl_picTtl">
          <div class="bl_ttlName">
            <div class="el_pastPic_logo">
              <img src="/img/pastPic_logo.png" alt="" />
            </div>
            <div class="el_pastPic_name">
              <p>過去の画像</p>
            </div>
          </div>

          <div class="bl_pull">
            <div class="bl_ttlDay">
              <select
                value={selectedDate}
                onChange={handleDateChange}
              >
                {dates.map((date) => (
                  <option
                    value={date}
                  >
                    {date}
                  </option>
                ))}
              </select>
            </div>
            <div class="bl_ttlTime">
              <select
                value={selectedtime}
                onChange={handleTimeChange}
              >
                {times.map((time) => (
                  <option
                    value={time}
                  >
                    {time}
                  </option>
                ))}
              </select>
          </div>

          </div>


        </div>


        <div class="bl_pastVideo">
          <div class="el_pastVideo_inner">
            {output_image(image)}
          </div>
        </div>

        <div class="bl_moveBtn">
          <div class="el_moveBtn_left">
            { nextTime !== undefined ?  <img src="/img/moveBtn_left.png" alt="" onClick={() => handleNextClick()}/> : "" }
          </div>
          <div class="el_moveBtn_right">
            { prevTime !== undefined ? <img src="/img/moveBtn_right.png" alt="" onClick={() => handlePrevClick()}/> : "" }
          </div>
        </div>
      </div>
    </div>
  )
}

export default PastContent
